import { IWorkerConfiguration } from "./base-knowledge-catalog";

export enum ItemStateEnum {
  SET = "Set",
  UNSET = "Unset"
}

export interface IItemState {
  idParent: string;
  state: ItemStateEnum;
}

export interface IAIBpmKnowledgeBase {
  kbCategories: IItemState[];
  kbCatalogs: IItemState[];
}

export interface IAiResponse {
  aIBpmKnowledgeBase: IAIBpmKnowledgeBase;
  aIWorkerConfiguration: IWorkerConfiguration;
  hasOverride: boolean;
}
